module.exports = __webpack_public_path__ + "media/assets/wgu-1203af3389a8f3e528f678119d89a78c.png";